import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import packageJson from '/package.json';

const profile = packageJson.profile;

console.log("Using profile: "+profile)
// firebase init
const firebaseConfig = {
  "prod": {
    apiKey: "AIzaSyAzks9StzSGG4dAyxWF6It30WGG_s0Wmfg",
    authDomain: "fibl-relacs.firebaseapp.com",
    projectId: "fibl-relacs",
    storageBucket: "fibl-relacs.appspot.com",
    messagingSenderId: "331987706502",
    appId: "1:331987706502:web:4d278c12fbea79bd512707",
  },
  "test": {
    projectId: "fibl-relacs-test",
    appId: "1:610706727511:web:8a568ca1609b4310a8b912",
    apiKey: "AIzaSyCMqpN4Agm_wDRXsNuZlEbdR9gx1QvKsGY",
  }
};

firebase.initializeApp(firebaseConfig[profile])

// utils
export const db = firebase.firestore()
export const auth = firebase.auth()

export const nutrientValuesCollection = db.collection('nutrient_values')
export const categoriesCollection = db.collection('categories')
export const usersCollection = db.collection('users')
export const projectsCollection = db.collection('projects')
export const regionsCollection = db.collection('regions')
export const unitsCollection = db.collection('units')
